import React from 'react';
import { usePlanoForm } from './Context';

const SelectPlanoForm = () => {
    const { setPlano, optionsPlano } = usePlanoForm();

    const handleSelect = (selectedPlanoId: string) => {
        const selectedPlano = optionsPlano.find(p => p._id === selectedPlanoId);
        if (selectedPlano) {
            setPlano(selectedPlano);
        }
    };

    return (
        <div className="grid grid-cols-1 gap-4">
            {optionsPlano.map(p => {
                return (
                    <div
                        key={p._id}
                        onClick={() => handleSelect(p._id)}
                        className={`cursor-pointer rounded-xl p-4 shadow-md transition-all duration-300 bg-base-100 hover:shadow-lg`}
                    >
                        <h2 className="text-lg font-semibold">{p.name}</h2>
                        <p className="text-xs">Duração: {p.durationInMonths} meses</p>
                        <p className="text-xs">Valor: R$ {p.price}</p>
                        <p className="text-xs">Frequência: {p.paymentFrequency}</p>
                        <p className="text-xs mt-2 font-light">{p.services.length} serviços incluídos</p>
                    </div>
                );
            })}
        </div>
    );
};

export default SelectPlanoForm;
